import { Style } from '../../../core/models/entities/Style'
import { StyleDto, StyleViewDto } from '../responses/StyleDto'
import { StyleView } from '../../../core/models/entities/StyleView'
import { mapToManufacturer } from './mapManufacturer'

export function mapToStyles(dto: StyleDto): Style {
  // Null-guards: a partial/degraded payload (e.g. a style ref embedded in a
  // design that hasn't been fully hydrated) must never throw inside
  // react-query's select — that flips the whole screen to the error view.
  return {
    ...dto,
    createdAtUtc: dto.createdAtUtc ? new Date(dto.createdAtUtc) : undefined,
    updatedAtUtc: dto.updatedAtUtc ? new Date(dto.updatedAtUtc) : undefined,
    styleViews: dto.styleViews ? dto.styleViews.map(mapToStyleView) : [],
    manufacturer: dto.manufacturer
      ? mapToManufacturer(dto.manufacturer)
      : (undefined as any)
  }
}

export function mapToStyleView(dto: StyleViewDto): StyleView {
  return { ...dto }
}
